// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"454":"fdbe5752","676":"53374526"}[chunkId] + ".chunk.js";
};